import { render, staticRenderFns } from "./ProductControls.vue?vue&type=template&id=0393d0cc"
import script from "./ProductControls.vue?vue&type=script&lang=js"
export * from "./ProductControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports